import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";

/**
 * Funnel name + description. Asked when a new funnel is saved, and opened from the funnel list
 * ("Funnel details") to rename an existing one.
 */
export default function FunnelDetailsModal({ show, title, initialName = "", initialDescription = "", saving = false, saveLabel = "Save", onCancel, onSave }) {
  const [name, setName] = useState(initialName);
  const [description, setDescription] = useState(initialDescription);

  useEffect(() => {
    if (!show) return;
    setName(initialName);
    setDescription(initialDescription);
  }, [show, initialName, initialDescription]);

  const submit = (e) => {
    e.preventDefault();
    if (!saving) onSave(name.trim(), description.trim());
  };

  return (
    <Modal show={show} onHide={() => !saving && onCancel()} centered className="ns-modal">
      <form onSubmit={submit}>
        <Modal.Header closeButton>
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="funnel-meta">
            <label htmlFor="funnel-name">Funnel name <span className="text-danger">*</span></label>
            <input
              id="funnel-name"
              className="form-control"
              placeholder="e.g. Install to first booking"
              maxLength={150}
              value={name}
              autoFocus
              onChange={(e) => setName(e.target.value)}
            />
          </div>
          <div className="funnel-meta">
            <label htmlFor="funnel-description">Description</label>
            <textarea
              id="funnel-description"
              className="form-control"
              rows={3}
              placeholder="Optional — what this funnel tracks"
              maxLength={500}
              value={description}
              onChange={(e) => setDescription(e.target.value)}
            />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button type="button" className="btn_theme_secondary" onClick={onCancel} disabled={saving}>
            Cancel
          </button>
          <button type="submit" className="add_app_btn btn_theme_primary" disabled={saving || !name.trim()}>
            <span>{saving ? "Saving…" : saveLabel}</span>
          </button>
        </Modal.Footer>
      </form>
    </Modal>
  );
}
